import { saveAs } from 'file-saver';

export default {
  computed: {
    hasFile() {
      return (this.item.file
        || this.item.assets?.documents?.length
        || this.item.assets?.images?.length
        || this.item.assets?.videos?.length
        || this.item.assets?.audios?.length);
    },
    file() {
      return this.hasFile ? Object.values(this.item.assets).find(item => item.length > 0)[0] : null;
    }
  },

  methods: {
    saveFile() {
      if (this.item.file) {
        return saveAs(this.item.file);
      }

      const { id, fileName } = this.file;
      return saveAs(`${process.env.VUE_APP_ASSETS_SERVICE_URL}/document/${id}`, fileName);
    }
  },
};
